import React from 'react';
import { Row, Col, Form, Select, Radio } from 'antd';
import { useTranslation } from 'react-i18next';

const PaymentMethodSelector = ({
  paymentMethodSelected,
  creditCardDetails,
  paymentMethodsAllowed,
  onSelectGroup,
  onSelectMethod,
  renderPaymentMethods
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="ant-collapse-header" style={{ marginTop: '10px' }}>
        {t('Campaign payment')}
      </div>
      <div className="ant-collapse-sub-header" style={{ paddingLeft: '10px' }}>
        {t('Payment method')}
      </div>

      <Form layout="inline">
        <Row type="flex" gutter={6} className="content-row">
          <Col xs={20}>
            <Radio.Group
              style={{ marginBottom: 20 }}
              onChange={e => onSelectGroup(e.target.value)}
              value={paymentMethodSelected}
            >
              {paymentMethodsAllowed.length > 0 && (
                <Radio value="other">{t('Pay with other means of payment')}</Radio>
              )}
            </Radio.Group>
          </Col>

          {paymentMethodSelected === 'other' && (
            <Col xs={6}>
              <Select
                value={
                  creditCardDetails.paymentMethodId === 'visa'
                    ? t('transfer')
                    : creditCardDetails.paymentMethodId
                }
                onChange={onSelectMethod}
              >
                {renderPaymentMethods('other')}
              </Select>
            </Col>
          )}
        </Row>
      </Form>
    </>
  );
};

export default PaymentMethodSelector;
